import {
  BANK_ACCOUNT_UNUSABLE_MESSAGE,
  DO_NOT_HONOR_MESSAGE,
  PAYMENT_METHOD_SKIP_VERIFICATION_FAILED_MESSAGE,
  STRIPE_DECLINE_MESSAGES,
} from '../../utils';
import { PaymentMethodError } from './types';

export const PAYMENT_METHOD_SKIP_VERIFICATION_FAILED = 'payment_method_skip_verification_failed';
export const BANK_ACCOUNT_UNUSABLE = 'bank_account_unusable';
export const CARD_DECLINED = 'card_declined';
export const DO_NOT_HONOR = 'do_not_honor';

export { BANK_ACCOUNT_UNUSABLE_MESSAGE, DO_NOT_HONOR_MESSAGE, PAYMENT_METHOD_SKIP_VERIFICATION_FAILED_MESSAGE };

export interface ErrorTitle {
  property: keyof PaymentMethodError;
  value: string;
  title: string;
}

export const errorTitles: ErrorTitle[] = [
  {
    property: 'code',
    value: BANK_ACCOUNT_UNUSABLE,
    title: 'We couldn’t validate this bank account'
  },
  {
    property: 'decline_code',
    value: DO_NOT_HONOR,
    title: 'We couldn’t validate this payment method'
  }
];

export const messageByCode: Record<string, string> = {
  [PAYMENT_METHOD_SKIP_VERIFICATION_FAILED]: PAYMENT_METHOD_SKIP_VERIFICATION_FAILED_MESSAGE,
  [BANK_ACCOUNT_UNUSABLE]: BANK_ACCOUNT_UNUSABLE_MESSAGE,
  [DO_NOT_HONOR]: STRIPE_DECLINE_MESSAGES[DO_NOT_HONOR],
};
